import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import {
  MarketingIntakeLayout,
  MarketingUnsubscribeContainer,
} from "@platform/features/marketing";

/**
 * Where the unsubscribe link in an announcement lands.
 *
 * Laid out as the site's intake pages are, so it reads as Pollinator's own
 * page rather than a bare server response. The link carries a token naming
 * the person, so nobody has to sign in, which matters while sign-in is closed.
 */
export default function UnsubscribePage() {
  const { token = "" } = useParams<{ token: string }>();
  return (
    <>
      <Helmet>
        <title>Pollinator | Unsubscribe</title>
      </Helmet>
      <MarketingIntakeLayout
        audienceLabel="Email"
        headline="Announcements"
        introBody={[
          "Announcements are the news, programs and funding opportunities we send to everyone in the Pollinator network.",
          "Unsubscribing from them doesn’t stop email about your meetings or about anything you’ve signed up for.",
        ]}
        mobileView="form"
      >
        <MarketingUnsubscribeContainer token={token} />
      </MarketingIntakeLayout>
    </>
  );
}
